// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2LvZO","notes":"Notes_notes__n7whk","note":"Notes_note__3R5Ns","markdown":"Notes_markdown__1wb2V"};